import { parseApiDateTime } from './messageConversations';

const isApplicantSender = (sender) => Boolean(sender && String(sender).includes(' - Applicant'));

export const getLatestSourceMessage = (msg) => {
  if (Array.isArray(msg?._sourceMessages) && msg._sourceMessages.length > 0) {
    return msg._sourceMessages[msg._sourceMessages.length - 1];
  }
  return msg;
};

export const getLastMessageSenderRole = (msg) => {
  const latest = getLatestSourceMessage(msg);
  const latestReply = latest?.replies?.length
    ? latest.replies[latest.replies.length - 1]
    : null;
  if (latestReply) return isApplicantSender(latestReply.sender) ? 'applicant' : 'admin';
  return !latest?.notification_type || latest.notification_type === 'contact_message'
    ? 'applicant'
    : 'admin';
};

export const isUnreadForAdmin = (msg) => getLastMessageSenderRole(msg) === 'applicant';
export const isUnreadForApplicant = (msg) => getLastMessageSenderRole(msg) === 'admin';

export const countUnreadConversations = (conversations = [], mode = 'admin') => (
  (conversations || []).filter((msg) => (
    mode === 'applicant' ? isUnreadForApplicant(msg) : isUnreadForAdmin(msg)
  )).length
);

export const getConversationActivityKey = (msg) => {
  const latest = getLatestSourceMessage(msg);
  const latestReply = latest?.replies?.length
    ? latest.replies[latest.replies.length - 1]
    : null;
  const id = latestReply?.id || latest?.id || msg?.id || '';
  const at = latestReply?.createdAt || latest?.createdAt || msg?.createdAt || '';
  return `${id}|${at}`;
};

export const collectChatFingerprint = (messages = []) => {
  const map = new Map();
  (messages || []).forEach((msg) => {
    const email = String(msg.email || msg.id || '').trim().toLowerCase();
    if (!email) return;
    map.set(email, getConversationActivityKey(msg));
  });
  return map;
};

export const findNewChatAlerts = (prevMap, nextMessages = [], mode = 'admin') => {
  if (!prevMap) return [];

  const alerts = [];
  (nextMessages || []).forEach((msg) => {
    const email = String(msg.email || msg.id || '').trim().toLowerCase();
    if (!email) return;

    const nextKey = getConversationActivityKey(msg);
    const prevKey = prevMap.get(email);
    if (prevKey === nextKey) return;

    const role = getLastMessageSenderRole(msg);
    const isRelevant = mode === 'admin' ? role === 'applicant' : role === 'admin';
    if (!isRelevant) return;

    const latest = getLatestSourceMessage(msg);
    const preview = String(latest?.message || msg.message || '').trim();
    alerts.push({
      id: `${email}-${nextKey}`,
      email,
      name: msg.name || email,
      preview: preview.slice(0, 80),
      role,
      createdAt: latest?.createdAt || msg.createdAt,
    });
  });

  alerts.sort((a, b) => {
    const da = parseApiDateTime(a.createdAt)?.getTime() || 0;
    const db = parseApiDateTime(b.createdAt)?.getTime() || 0;
    return db - da;
  });

  return alerts;
};
